<template>
  <nav class="bg-gray-800 h-28 py-1 md:py-1">
    <div class="container h-full px-2 mx-auto md:flex md:items-center">
      <div class="flex h-full justify-between items-center">
        <div class="flex flex-wrap float-left justify-left">
          <img
            class="object-contain w-40 h-auto float-left"
            id="rhul-logo"
            alt="rhul-logo"
            src="https://www.royalholloway.ac.uk/images/logoRoyalHolloway2x.png"
          />
        </div>
        <div class="hidden mx-2 w-48 md:block" id="header-text">
          <div
            class="
              font-bold
              text-l
              mx-2
              text-white
              w-full
              \
              overflow-hidden
              whitespace-no-wrap
            "
            id="computer-science"
          >
            Computer Science
          </div>
          <div
            class="
              font-bold
              text-l
              mx-2
              text-rhulorange
              w-full
              \
              overflow-hidden
              whitespace-no-wrap
            "
            id="module-selector"
          >
            Module Selector
          </div>
        </div>
        <div class="visible md:invisible">
          <select @change="handleMenuChange($event)">
            <option
              class="
                    w-full
                    block
                    px-4
                    py-2
                    text-sm
                    leading-5
                    text-gray-700
                    transition
                    duration-150
                    ease-in-out
                    hover:bg-gray-100
                    focus:outline-none
                    focus:bg-gray-100
                  "
              role="menuitem"
              selected="selected"
              disabled="disabled"
            >
              Options…
            </option>
            <option
              v-for="item in items"
              :key="item.id"
              class="
                    w-full
                    block
                    px-4
                    py-2
                    text-sm
                    leading-5
                    text-gray-700
                    transition
                    duration-150
                    ease-in-out
                    hover:bg-gray-100
                    focus:outline-none
                    focus:bg-gray-100
                  "
              role="menuitem"
            >
              {{ item }}
            </option>
            <option
              class="
                    w-full
                    block
                    px-4
                    py-2
                    text-sm
                    leading-5
                    text-gray-700
                    transition
                    duration-150
                    ease-in-out
                    hover:bg-gray-100
                    focus:outline-none
                    focus:bg-gray-100
                  "
              role="menuitem"
            >
              Logout
            </option>
          </select>
        </div>
      </div>

      <div
        class="hidden md:flex flex-col md:flex-row md:ml-auto mt-3 md:mt-0"
        id="navbar-collapse"
      >
        <div
          class="
            text-l
            bg-grey-light
            hover:bg-grey
            text-white
            font-bold
            py-2
            px-4
            rounded
            inline-flex
            items-center
          "
        >
          <i class="far fa-user-circle mx-2 text-rhulorange"></i>
          <span> {{ name }} </span>
        </div>

        <button
          class="
            group
            text-l
            bg-grey-light
            hover:bg-grey
            text-white
            font-bold
            py-2
            px-4
            rounded
            inline-flex
            items-center
            hover:text-rhulorange
            transition
            duration-150
            ease-in-out
          "
          type="logout"
          @click="handleLogout"
        >
          <i class="fas fa-sign-out-alt mx-2"></i>
          <span>Log out</span>
        </button>
      </div>
    </div>
    <!-- <div class='user'>
      <div id='user-name' class='primary-color'>{{ name }}</div>
      <button type='logout' @click='handleLogout'>Logout</button>
    </div> -->
  </nav>
</template>

<script>

import ChooseModules from './ChooseModules';
import MySelection from './MySelection';

export default {
  props: ['items', 'parentHandler'],
  data: () => ({
    name: localStorage.getItem('name'),
    ChooseModules,
    MySelection,
  }),
  methods: {
    handleMenuChange(event) {
      console.log('Event target:', event.target.value);
      if (event.target.value === 'Logout') {
        this.handleLogout();
        return;
      }
      this.parentHandler(event.target.value.replace(/\s/g, ''));
    },

    /**
     * Removes all webtokens which were assigned to the user.
     */
    handleLogout() {
      localStorage.removeItem('jwt');
      localStorage.removeItem('user');
      localStorage.removeItem('name');
      localStorage.removeItem('student');
      localStorage.removeItem('academic');
      localStorage.removeItem('office');
      window.location.href = '/';
    },
  },
};
</script>

<style scoped></style>
